import React, { Component } from 'react'
import { connect } from 'react-redux'

import _ from 'lodash'

class BkFlowRoomCardDefaultSelectButton extends Component {
  render() {
    const {
      activeStep,
      availabilityData,
      configData,
      currentRateCode,
      currentRoomType,
      currentUpSells,
      enhancementData,
      loyaltyRatesData,
      multiRoomData,
      roomGroup,
      toggleActiveRoom,
      upSellsToggleEvent,
      urlData
    } = this.props
    const hotelLabels = configData.hotel.labels[0]

    let activeHotelCode = null,
        activeHotelPhoneNumber = null,
        renderRoomSelectButton = []

    // Get hotel code from avail response
    if (
      !_.isEmpty(urlData) &&
      urlData.hotelCode
    ) {
      activeHotelCode = urlData.hotelCode
    }

    if (!_.isEmpty(configData)) {
      let configProperties = configData.hotel.options.properties,
        matchedProperty = null

      if (
        configData.hotel &&
        configData.hotel.options &&
        configData.hotel.options.properties
      ) {
        configProperties = configData.hotel.options.properties
      }

      // Match activeHotelCode to config properties array
      if (!_.isEmpty(configProperties)) {
        matchedProperty = configProperties.find(function(property) {
          return property.hotelCode === String(activeHotelCode)
        })
      }

      // Set phone # by config or crs fallback
      if (
        !_.isEmpty(matchedProperty) &&
        matchedProperty.contactNumbers &&
        matchedProperty.contactNumbers.reservations
      ) {
        activeHotelPhoneNumber = matchedProperty.contactNumbers.reservations
      } else if (
        !_.isEmpty(availabilityData.hotelReservations) &&
        availabilityData.hotelReservations[0] &&
        availabilityData.hotelReservations[0].roomStays &&
        _.get(availabilityData.hotelReservations[0].roomStays, '[0].basicPropertyInfo.contactNumbers[0].phoneNumber')
      ) {
        activeHotelPhoneNumber = availabilityData.hotelReservations[0].roomStays[0].basicPropertyInfo.contactNumbers[0].phoneNumber
      }
    }

    const activeLoyaltyAvailability = _.get(loyaltyRatesData, currentRateCode, {})
    if (
      currentRoomType &&
      currentRateCode &&
      !_.isEmpty(currentUpSells)
    ) {
      return (
        <div className="bk-flow-room__submit">
          <button
            className="btn btn-transparent btn-xl flex center-xs"
            onClick={() => upSellsToggleEvent() }
          >
            { hotelLabels.selectRoomContinue ? hotelLabels.selectRoomContinue : 'Select Room & Continue' }
          </button>
        </div>
      )
    } else if (
      currentRoomType &&
      currentRateCode
    ) {
      renderRoomSelectButton.push(
        <div
          key="room-select-button"
          className="bk-flow-room__submit"
        >
          <button
            className="btn btn-transparent btn-xl flex center-xs"
            onClick={
              () => toggleActiveRoom(
                availabilityData,
                currentRoomType,
                currentRateCode,
                roomGroup,
                activeStep,
                multiRoomData,
                configData,
                urlData,
                enhancementData,
                null,
                activeLoyaltyAvailability
              )
            }
          >
            { hotelLabels.selectRoomContinue ? hotelLabels.selectRoomContinue : 'Select Room & Continue' }
          </button>
        </div>
      )
    } else {
      renderRoomSelectButton.push(
        <div
          key="room-skip-step-button"
          className="bk-flow-room__pricing-unavailable"
        >
          <h4>{ hotelLabels && hotelLabels.unavailableRoomTitle ? hotelLabels.unavailableRoomTitle : 'Change in Plans?' }</h4>
          <p>
            { hotelLabels &&
              hotelLabels.unavailableRoomMessage ?
              hotelLabels.unavailableRoomMessage
            :
              'Dates can’t budge? Choose a different room. If you love this room, select different dates or call:'
            }
          </p>
          { activeHotelPhoneNumber && <a href={ 'tel:' + activeHotelPhoneNumber }>{ activeHotelPhoneNumber }</a> }
        </div>
      )
    }

    return renderRoomSelectButton
  }
}

function mapStateToProps(state) {
  return {
    activeStep: state.activeStepData.activeStep,
    availabilityData: state.availabilityData.availability,
    configData: state.configData.configuration,
    enhancementData: state.enhancementData,
    loyaltyRatesData: state.loyaltyRatesData.availability,
    multiRoomData: state.multiRoomData,
    urlData: state.availabilityData.urlData,
  }
}

export default connect(mapStateToProps, null)(BkFlowRoomCardDefaultSelectButton)



// WEBPACK FOOTER //
// ./src/components/room/elements/default/configured/BkFlowRoomCardDefaultSelectButton.js